var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EdelError = /** @class */ (function (_super) {
    __extends(EdelError, _super);
    function EdelError(code, error) {
        var _this = _super.call(this) || this;
        _this.getHttpCode = function () {
            if (!_this.httpCode)
                return 0;
            return _this.httpCode;
        };
        _this.getErrorCode = function () {
            var _a, _b, _c, _d;
            if (_this.errorParams == null && ((_b = (_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errorCode) == null)
                return "0";
            return (_d = (_c = _this.errorParams) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.errorCode;
        };
        _this.getErrorMessege = function () {
            var _a, _b, _c, _d;
            if (_this.errorParams == null ||
                ((_b = (_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errorMessage) == null)
                return "Something went wrong";
            return (_d = (_c = _this.errorParams) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.errorMessage;
        };
        _this.getErrCd = function () {
            var _a, _b;
            if (_this.errorParams == null || ((_b = (_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errCd) == null)
                return "0";
            return _this.errorParams.error.errCd;
        };
        _this.getErrMsg = function () {
            var _a, _b, _c, _d;
            if (_this.errorParams == null || ((_b = (_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errMsg) == null)
                return "Something went wrong! Please try after sometime.";
            return (_d = (_c = _this.errorParams) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.errMsg;
        };
        _this.getActionCode = function () {
            if (_this.errorParams == null || _this.errorParams.error.actionCode == null)
                return "Something went wrong! Please try after sometime.";
            return _this.errorParams.error.actionCode;
        };
        _this.getStatus = function () {
            if (_this.errorParams == null)
                return false;
            return _this.errorParams.status;
        };
        _this.getErrorMessageOrErrMsg = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (_this.errorParams == null &&
                ((_b = (_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errMsg) == null &&
                ((_d = (_c = _this.errorParams) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.errorMessage) == null)
                return "Something went wrong! Please try after sometime.";
            return (((_f = (_e = _this.errorParams) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.errorMessage) || ((_h = (_g = _this.errorParams) === null || _g === void 0 ? void 0 : _g.error) === null || _h === void 0 ? void 0 : _h.errMsg));
        };
        _this.getMessage = function () {
            if (_this.errorParams == null || _this.errorParams.message === null)
                return "Something went wrong! Please try after sometime.";
            return _this.errorParams.message;
        };
        _this.getErrors = function () {
            var _a;
            if (_this.errorParams == null ||
                _this.errorParams.error.errors === null ||
                ((_a = _this.errorParams.error.errors) === null || _a === void 0 ? void 0 : _a.length) == 0)
                return "Something went wrong! Please try after sometime.";
            return _this.errorParams.error.errors;
        };
        _this.errorMsgOfSales = function () {
            return "We ran in to some technical difficulties. Please refresh the page or try again.";
        };
        _this.getErrorData = function () {
            var _a, _b;
            if (_this.errorParams === null ||
                ((_a = _this.errorParams) === null || _a === void 0 ? void 0 : _a.data) === null ||
                ((_b = _this.errorParams) === null || _b === void 0 ? void 0 : _b.data) === undefined)
                return "Something went wrong! Please try after sometime.";
            return _this.errorParams.data;
        };
        _this.getErrorsObject = function () {
            var _a;
            if (_this.errorParams == null ||
                _this.errorParams.errors === null ||
                ((_a = _this.errorParams.errors) === null || _a === void 0 ? void 0 : _a.length) == 0)
                return "Something went wrong! Please try after sometime.";
            return _this.errorParams.errors;
        };
        Object.setPrototypeOf(_this, EdelError.prototype);
        _this.httpCode = code;
        _this.errorParams = error;
        return _this;
    }
    return EdelError;
}(Error));
export { EdelError };
